import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useAgGridTableContext } from 'core/states';
import { CorporateUserStatus } from 'corporate/enums';
import { corporateUserService } from 'corporate/services';
import { ICorporateUserAutocomplete } from 'corporate/types';
import { QuoteEntityType } from 'quotes/enums';
import { IReassignQuoteForm } from 'quotes/types';

interface IProps {
  isOpen: boolean;
  onSubmit?: (reset?: UseFormReset<IReassignQuoteForm>) => (data: IReassignQuoteForm) => void;
  onClose: (reset: UseFormReset<IReassignQuoteForm>) => void;
  entityType: QuoteEntityType;
}

export const ReassignQuote = ({
  isOpen,
  onSubmit,
  onClose,
  entityType = QuoteEntityType.QUOTE,
}: IProps) => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridTableContext();

  return (
    <Form
      title={t('titleReassignQuote', { entityType, count: selectedRows?.length })}
      isOpen={isOpen}
      onSubmit={onSubmit}
      onClose={onClose}
      cancelBtnLabel={t('buttonLabelCancel')}
      submitBtnLabel={t('buttonLabelReassign')}
    >
      <FormField
        name="corporateUser"
        type={InputType.AUTOCOMPLETE}
        inputProps={{
          label: t('labelUser'),
          getOptions: corporateUserService.getCorporateUsersAutocomplete,
          requestPayload: {
            filters: {
              status: [CorporateUserStatus.ACTIVE],
            },
          },
          getLabel: (option: ICorporateUserAutocomplete) => option.name,
          required: true,
        }}
      />
    </Form>
  );
};
